import React, { useState } from 'react';
import { getHastalar, yeniHasta } from '../services/api';

// Yeni Kabul Yap ekranındaki "Hasta Seç" popup'ı — CHK'de arama (min 3 harf) + tek seçim + "Yeni
// Hasta Kayıt" alt-formu. Seçilen/oluşturulan hasta onSec(hasta) ile üst bileşene teslim edilir
// (kullanıcı talebi: 2026-08-09).
//
// SELECT * FROM CHK WHERE IPTAL=0 AND KARTKOD=1 AND HESAPADI LIKE '%...%' — mevcut getHastalar zaten
// bu filtreyi uyguluyor (ayrıca TcKimlik/Tel ile de eşleşiyor, bu daha kullanışlı olduğu için aynen
// kullanıldı).
const bosForm = { hesapAdi: '', dogTar: '', cinsiyet: 'K', tcKimlik: '', cepTel: '', adres1: '' };

const yyyyMmDdToTr = (d) => {
  if (!d) return '';
  const [yil, ay, gun] = d.split('-');
  return `${ay}/${gun}/${yil}`;
};

export default function HastaSecModal({ onKapat, onSec }) {
  const [gorunum, setGorunum] = useState('ara'); // 'ara' | 'yeniKayit'

  // --- Arama görünümü ---
  const [aramaMetni, setAramaMetni] = useState('');
  const [aramaHata, setAramaHata] = useState('');
  const [araniyor, setAraniyor] = useState(false);
  const [aramaDeneme, setAramaDeneme] = useState(false);
  const [sonuclar, setSonuclar] = useState([]);

  const araYap = async (e) => {
    e?.preventDefault();
    const deger = aramaMetni.trim();
    if (deger.length < 3) { setAramaHata('Arama için en az 3 karakter girin.'); return; }
    setAramaHata(''); setAraniyor(true); setAramaDeneme(true);
    try {
      const res = await getHastalar(deger);
      setSonuclar(res.data);
    } catch (err) {
      setAramaHata(err.response?.data?.hata || 'Arama yapılamadı.');
    } finally {
      setAraniyor(false);
    }
  };

  // --- Yeni Hasta Kayıt görünümü ---
  const [form, setForm] = useState(bosForm);
  const [kayitHata, setKayitHata] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [cakisma, setCakisma] = useState(null); // aynı isimde bulunan mevcut hasta(lar)

  const alanDegisti = (alan, deger) => setForm(prev => ({ ...prev, [alan]: deger }));

  const formGecerli = form.hesapAdi.trim() && form.dogTar && form.cinsiyet && form.cepTel.trim();

  const gercektenKaydet = async () => {
    setKaydediliyor(true);
    setKayitHata('');
    try {
      const res = await yeniHasta({
        hesapAdi: form.hesapAdi.trim(),
        dogTar: yyyyMmDdToTr(form.dogTar),
        cinsiyet: form.cinsiyet,
        tcKimlik: form.tcKimlik.trim() || null,
        cepTel: form.cepTel.trim(),
        adres1: form.adres1.trim() || null,
        kartKod: 1,
        iptal: 0,
      });
      onSec(res.data);
    } catch (err) {
      setKayitHata(err.response?.data?.hata || 'Hasta kaydedilemedi.');
    } finally {
      setKaydediliyor(false);
    }
  };

  const kaydetTiklandi = async () => {
    if (!formGecerli) { setKayitHata('Zorunlu (*) alanları doldurun.'); return; }
    setKayitHata(''); setCakisma(null); setKaydediliyor(true);
    try {
      const res = await getHastalar(form.hesapAdi.trim());
      const araninanIsim = form.hesapAdi.trim().toLocaleLowerCase('tr-TR');
      const eslesenler = res.data.filter(h => (h.hesapAdi || '').trim().toLocaleLowerCase('tr-TR') === araninanIsim);
      setKaydediliyor(false);
      if (eslesenler.length > 0) {
        setCakisma(eslesenler);
        return;
      }
      await gercektenKaydet();
    } catch (err) {
      setKaydediliyor(false);
      setKayitHata(err.response?.data?.hata || 'Kontrol yapılamadı.');
    }
  };

  const yeniKayitGorunumeGec = () => {
    setForm(bosForm);
    setKayitHata('');
    setCakisma(null);
    setGorunum('yeniKayit');
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
      <div className="card" style={{ width: 520, maxWidth: '92vw', maxHeight: '86vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ margin: 0, fontSize: 14, color: 'var(--med-dark)' }}>
            {gorunum === 'ara' ? 'Hasta Seç' : 'Yeni Hasta Kayıt'}
          </h3>
          <button onClick={onKapat} className="btn btn-secondary" style={{ fontSize: 12, padding: '4px 10px' }}>✕</button>
        </div>

        {gorunum === 'ara' ? (
          <>
            <form onSubmit={araYap} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <input
                type="text"
                placeholder="Hasta adı yazın (en az 3 karakter)..."
                value={aramaMetni}
                onChange={e => setAramaMetni(e.target.value)}
                autoFocus
                style={{ flex: 1 }}
              />
              <button type="submit" disabled={araniyor} className="btn btn-primary">
                {araniyor ? '...' : '🔍 Ara'}
              </button>
            </form>
            {aramaHata && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 8 }}>{aramaHata}</div>}

            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 8, marginBottom: 10, minHeight: 160 }}>
              {araniyor ? (
                <div className="loading">Aranıyor...</div>
              ) : !aramaDeneme ? (
                <div className="empty">Aramak için yukarıdan yazıp Ara'ya basın</div>
              ) : sonuclar.length === 0 ? (
                <div className="empty">Sonuç bulunamadı</div>
              ) : (
                sonuclar.map(h => (
                  <div
                    key={h.kayitNo}
                    onClick={() => onSec(h)}
                    style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '10px 14px', borderBottom: '1px solid var(--border)', cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8faf9'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{ fontWeight: 500, fontSize: 13 }}>{h.hesapAdi}</span>
                    <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                      #{h.kayitNo} · {h.tcKimlik || '—'} · {h.cinsiyet === 'E' ? 'Erkek' : h.cinsiyet === 'K' ? 'Kadın' : '—'} · {h.dogTar || '—'}
                    </span>
                  </div>
                ))
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button onClick={yeniKayitGorunumeGec} className="btn btn-secondary" style={{ fontSize: 12 }}>➕ Yeni Hasta Kayıt</button>
              <button onClick={onKapat} className="btn btn-secondary">Vazgeç</button>
            </div>
          </>
        ) : (
          <>
            <div style={{ flex: 1, overflowY: 'auto', marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div>
                <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Adı Soyadı *</label>
                <input type="text" value={form.hesapAdi} onChange={e => alanDegisti('hesapAdi', e.target.value)} style={{ width: '100%' }} autoFocus />
              </div>

              <div style={{ display: 'flex', gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Doğum Tarihi *</label>
                  <input type="date" value={form.dogTar} onChange={e => alanDegisti('dogTar', e.target.value)} style={{ width: '100%' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Cinsiyet *</label>
                  <div style={{ display: 'flex', gap: 14, height: 34, alignItems: 'center' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, cursor: 'pointer' }}>
                      <input type="radio" name="cinsiyet" checked={form.cinsiyet === 'E'} onChange={() => alanDegisti('cinsiyet', 'E')} /> Erkek
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, cursor: 'pointer' }}>
                      <input type="radio" name="cinsiyet" checked={form.cinsiyet === 'K'} onChange={() => alanDegisti('cinsiyet', 'K')} /> Kadın
                    </label>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>TC Kimlik No</label>
                  <input type="text" value={form.tcKimlik} onChange={e => alanDegisti('tcKimlik', e.target.value.replace(/\D/g, '').slice(0, 11))} style={{ width: '100%' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Cep Telefonu *</label>
                  <input type="tel" value={form.cepTel} onChange={e => alanDegisti('cepTel', e.target.value)} style={{ width: '100%' }} />
                </div>
              </div>

              <div>
                <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Adresi</label>
                <textarea rows={2} value={form.adres1} onChange={e => alanDegisti('adres1', e.target.value)} style={{ width: '100%', resize: 'vertical', fontFamily: 'inherit' }} />
              </div>
            </div>

            {kayitHata && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 8 }}>{kayitHata}</div>}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button onClick={() => setGorunum('ara')} className="btn btn-secondary" style={{ fontSize: 12 }}>◀ Geri</button>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={onKapat} className="btn btn-secondary">Vazgeç</button>
                <button onClick={kaydetTiklandi} disabled={kaydediliyor || !formGecerli} className="btn btn-primary">
                  {kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </div>
            </div>
          </>
        )}

        {cakisma && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200 }}>
            <div className="card" style={{ width: 420, maxWidth: '90vw' }}>
              <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--med-dark)', marginBottom: 10 }}>
                Bu isimde bir hasta kaydı var
              </div>
              <div style={{ fontSize: 13, marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
                {cakisma.map(h => (
                  <div key={h.kayitNo} style={{ background: '#f8faf9', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 12px' }}>
                    <div style={{ fontWeight: 500 }}>{h.hesapAdi} <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>· #{h.kayitNo}</span></div>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
                      Doğum Tarihi: {h.dogTar || '—'} · TC Kimlik: {h.tcKimlik || '—'} · Cep Telefonu: {h.cepTel || '—'}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 13, marginBottom: 14 }}>
                Yine de bu yeni hastayı farklı bir hasta gibi kaydetmek istiyor musunuz?
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button onClick={() => setCakisma(null)} className="btn btn-secondary">Vazgeç</button>
                <button onClick={() => { setCakisma(null); gercektenKaydet(); }} disabled={kaydediliyor} className="btn btn-primary">
                  Evet, Devam Et
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
